interface AgentModeToggleProps {
  agentMode: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
}

export default function AgentModeToggle({ agentMode, onChange, disabled }: AgentModeToggleProps) {
  return (
    <label className="flex cursor-pointer items-center gap-2 text-sm text-slate-200">
      <span className="text-xs text-zt-muted">Agent mode</span>
      <button
        type="button"
        role="switch"
        aria-checked={agentMode}
        disabled={disabled}
        onClick={() => onChange(!agentMode)}
        className={`relative h-6 w-11 rounded-full transition ${
          agentMode ? 'bg-zt-primary' : 'bg-zt-elevated'
        } ${disabled ? 'opacity-50' : ''}`}
      >
        <span
          className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition ${
            agentMode ? 'left-5' : 'left-0.5'
          }`}
        />
      </button>
      <span className="text-xs text-zt-muted">{agentMode ? 'Full orchestrator' : 'Chat only'}</span>
    </label>
  );
}
